import CompanyProfile from '../Assets/img-min/svg/presentation2.svg';
import { VscWorkspaceTrusted } from "react-icons/vsc";
import { FaUserClock } from "react-icons/fa6";
import { RiTeamLine } from "react-icons/ri"
function Profile() {
  return (
    <div id="profile" className="section py-6 py-md-7 bg-body">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="text-center">
              <div className="px-5 px-md-6 mb-5 mb-lg-0">
                <img className="img-fluid" src={CompanyProfile} alt="company profile" />
              </div>
            </div>
          </div>
          <div className="col-lg-6" data-aos="flip-up">
            <div className="py-0">
              <h2 className="fw-bold mb-3">WHO WE ARE</h2>
              <h4 className="mb-3">We make Software, Web Application & Design</h4>
              <div className="mt-3">
                <ul className="ps-0 list-unstyled">                 
                  <li className="py-2">
                    <div className="p-3 float-start me-4 rounded bg-primary text-white">
                      <RiTeamLine style={{ fontSize: 28 }} />
                    </div>
                    <div className="list-text">
                      <strong >Exceptional Team</strong>
                      <p> Our team consists of highly skilled and motivated professionals dedicated to meeting client needs with quality and timely delivery.</p>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="p-3 float-start me-4 mb-2 rounded bg-primary text-white">
                      <VscWorkspaceTrusted style={{ fontSize: 28 }} />
                    </div>
                    <div className="list-text">
                      <strong>Client Trust</strong>
                      <p>At <strong>Viable Informatics Clues</strong>, maintaining the trust and confidence of our customers is of utmost importance to us. We prioritize client satisfaction above all else.</p>
                    </div>
                  </li>
                  <li className="py-2">
                    <div className="p-3 float-start me-4 rounded bg-primary text-white" style={{marginBottom:' 50px'}}>
                      <FaUserClock style={{ fontSize: 28 }} />
                    </div>
                    <div className="list-text">
                      <strong >Round-the-Clock Support</strong>
                      <p>With 13 years of experience in the IT sector, we now operate as a Private Limited Company, providing 24x7 support under the guidance of experienced managers. </p> {/*We focus on meticulous attention to detail, believing that it's the foundation for building reliable platforms that give businesses an edge over their competitors through our e-support services. */}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Profile;